// Accounting › Fixed assets — Asset Register tab, the asset window and form, import, reconciliation (prefix aw_far_). Batch 9 R4.
// Rules (as every mt package): no _plural keys; numbers as {{n}}; no empty value in any language.
// The tab names and the six statuses are facommon's (aw_fa_*); Export is the workspace's (aw_export).
export const en: Record<string, string> = {
  // ── the register (COA-H4 list, H12 export) ──
  aw_far_search_ph: 'Search asset no., name, supplier, invoice no., location or category',
  aw_far_status_filter: 'Status',
  aw_far_status_held: 'Still held',
  aw_far_status_all: 'All',
  aw_far_status_removed: 'Removed',
  aw_far_cat_filter: 'Category',
  aw_far_cat_all: 'All categories',
  aw_far_cat_none: 'No category',
  aw_far_from: 'Purchased from',
  aw_far_to: 'Purchased to',
  aw_far_clear: 'Clear the search and filters',
  aw_far_add: 'Add asset',
  aw_far_add_title: 'Register a new asset',
  aw_far_import: 'Import',
  aw_far_import_title: 'Load a whole register from a CSV or Excel file',
  aw_far_recon_btn: 'Reconcile with the ledger',
  aw_far_recon_btn_title: 'Compare the register with the general ledger\'s asset and accumulated depreciation balances',
  aw_far_register_pdf: 'Statutory register (PDF)',
  aw_far_register_pdf_title: 'The asset register in the DBD movement format, for this accounting period',
  aw_far_sum_assets: 'Assets',
  aw_far_sum_cost: 'Cost',
  aw_far_sum_accum: 'Accumulated depreciation',
  aw_far_sum_nbv: 'Net book value',
  aw_far_sum_sub: 'Of what the filters show',
  aw_far_sum_held: '{{n}} of them still held — the amounts are theirs',
  aw_far_sum_removed_sub: 'Removed — counted in no figure',
  aw_far_col_no: 'Asset No.',
  aw_far_col_name: 'Name',
  aw_far_col_category: 'Category',
  aw_far_col_start: 'Start date',
  aw_far_col_cost: 'Cost',
  aw_far_col_accum: 'Accumulated',
  aw_far_col_nbv: 'Net book value',
  aw_far_col_status: 'Status',
  aw_far_col_actions: 'Actions',
  aw_far_sort_title: 'Sort by this column',
  aw_far_open: 'Open',
  aw_far_open_title: 'Open this asset',
  aw_far_none: 'No asset matches the search and filters.',
  aw_far_start_title: 'Depreciation starts on this day: the depreciation start date, else the available-for-use date, else the purchase date',
  aw_far_no_category_title: 'No category — registered before every asset needed one',
  aw_far_overrides_title: 'Set by hand, not taken from its category: {{list}}',
  aw_far_ovr_rate: 'rate',
  aw_far_ovr_method: 'method',
  aw_far_ovr_asset_account: 'asset account',
  aw_far_ovr_accum_account: 'accumulated depreciation account',
  aw_far_ovr_expense_account: 'depreciation expense account',
  aw_far_files_title: '{{n}} supporting document(s)',
  aw_far_source_title: 'Bought on an Expense record',
  aw_far_nocat_title: 'Assets need a category first',
  aw_far_nocat_body: 'Every asset belongs to a category — its accounts, depreciation rate and method come from it. This client has no active asset category yet.',
  aw_far_nocat_btn: 'Set up asset categories',
  aw_far_not_found: 'Asset {{no}} is not on the register.',
  aw_far_imported: 'The register was imported — the new assets are in the list below.',
  aw_far_note: 'Cost is the purchase price plus any capitalised costs. The cards add up the assets still held among what the search and filters show: an asset that has been disposed of or written off took its cost and accumulated depreciation with it, so it carries no book value (—) and no card counts it.',
  aw_far_nbv_gone_title: 'Left the register — it was carried at {{amount}} when it went',
  aw_far_removed_by: 'Removed by {{who}}',
  aw_far_removed_note: 'Removed assets were registered by mistake and taken off the register. They stay listed here, struck through, with who removed them and when — open one to read its history. No figure on this screen counts them.',
  aw_far_cat_err: 'The asset categories could not be read: {{why}}',
  // ── the import (COA-H11 + H3) ──
  aw_far_imp_title: 'Import an asset register',
  aw_far_imp_cat: 'Category for rows without their own',
  aw_far_imp_cat_none: '— Each row names its own category —',
  aw_far_imp_file: 'File (.csv or .xlsx)',
  aw_far_imp_help: 'The first row names the columns, in English, Thai or Chinese, in any order. Required: a name (“Name”, and “Thai name” if you keep one), the purchase date (“Purchase date”, “Acquired” or “Date”) and the cost (“Cost”). Optional: “Category”, “Asset class”, “Rate”, “Residual”, “Asset account”, “Accumulated account” and “Expense account” (by code), “Accumulated brought forward” with “Brought forward to”, “Note”, “Supplier”, “Invoice no.”, “Capitalised cost”, “Available date”, “Depreciation start”, “Location”, “Status” (“in use”, “not yet available” or “idle”) and “Useful life (years)”. A column with any other heading is ignored, and the preview names it. Nothing is written until you import — and then every row, or none.',
  aw_far_imp_preview: 'Preview',
  aw_far_imp_commit: 'Import {{n}} asset(s)',
  aw_far_imp_summary: '{{ok}} row(s) can be registered · {{refused}} refused',
  aw_far_imp_fix: 'The refused rows are listed first. Fix them in the file and preview it again — an import is all rows or none.',
  aw_far_imp_stale: 'The file or the category has changed since the preview — preview it again.',
  aw_far_imp_col_line: 'Line',
  aw_far_imp_col_date: 'Purchase date',
  aw_far_imp_col_name: 'Name',
  aw_far_imp_col_category: 'Category',
  aw_far_imp_col_cost: 'Cost',
  aw_far_imp_col_verdict: 'Result',
  aw_far_imp_ok: 'Will be registered',
  aw_far_imp_for_file: 'chosen for the file',
  // ── the columns the preview read, and the ones it will not (review R4 #15, follow-up) ──
  aw_far_imp_read: 'Columns read:',
  aw_far_imp_ignored: '{{n}} column(s) will be ignored — nothing in them is registered. If one of them matters, rename its heading to one the help above names (or remove the column) and preview again.',
  aw_far_imp_column_n: 'Column {{n}}:',
  aw_far_imp_no_heading: '(no heading)',
  aw_far_imp_twice: 'a second {{field}} column — only the first one is read',
  aw_far_imp_f_name_th: 'Name (Thai)',
  aw_far_imp_f_name_en: 'Name (English)',
  aw_far_imp_f_class: 'Asset class',
  aw_far_imp_f_category: 'Category',
  aw_far_imp_f_acquired: 'Purchase date',
  aw_far_imp_f_cost: 'Cost',
  aw_far_imp_f_salvage: 'Residual value',
  aw_far_imp_f_rate: 'Depreciation rate',
  aw_far_imp_f_asset_account: 'Asset account',
  aw_far_imp_f_accum_account: 'Accumulated depreciation account',
  aw_far_imp_f_expense_account: 'Depreciation expense account',
  aw_far_imp_f_opening_accum: 'Accumulated brought forward',
  aw_far_imp_f_opening_as_of: 'Brought forward to',
  aw_far_imp_f_note: 'Note',
  aw_far_imp_f_vendor: 'Supplier',
  aw_far_imp_f_invoice_no: 'Supplier invoice no.',
  aw_far_imp_f_capitalised: 'Capitalised cost',
  aw_far_imp_f_available: 'Available for use',
  aw_far_imp_f_dep_start: 'Depreciation start',
  aw_far_imp_f_location: 'Location / department',
  aw_far_imp_f_status: 'Status',
  aw_far_imp_f_life: 'Useful life (years)',
  // ── the reconciliation (COA-H14) ──
  aw_far_rec_title: 'Register against the general ledger',
  aw_far_rec_asof: 'As at {{date}}',
  aw_far_rec_explain: 'Reasons are causes both sides prove on their own, so they are subtracted from the difference. Notes are worth knowing but prove nothing, so they are never subtracted. What remains is the unexplained difference.',
  aw_far_rec_cost: 'Cost',
  aw_far_rec_accum: 'Accumulated depreciation',
  aw_far_rec_col_account: 'Account',
  aw_far_rec_col_register: 'Register',
  aw_far_rec_col_ledger: 'Ledger',
  aw_far_rec_col_diff: 'Difference',
  aw_far_rec_total: 'Total',
  aw_far_rec_nbv: 'Net book value',
  aw_far_rec_no_accounts: 'No asset on the register uses an account here.',
  aw_far_rec_reasons: 'Reasons — subtracted',
  aw_far_rec_notes: 'Notes — never subtracted',
  aw_far_rec_none: 'None.',
  aw_far_rec_r_depreciation_in_draft: 'Depreciation on the register whose journal entry is still a draft ({{n}} asset(s)) — post it under Journal entries.',
  aw_far_rec_r_depreciation_without_an_entry: 'Depreciation on the register with no journal entry behind it at all ({{n}} asset(s)).',
  aw_far_rec_r_disposal_not_posted: 'Disposed of on the register while the disposal entry is not posted yet ({{n}} asset(s)).',
  aw_far_rec_n_no_acquisition_entry_of_its_own: 'No acquisition entry of its own ({{n}} asset(s)) — the cost usually reached the ledger through the purchase that bought it.',
  aw_far_rec_n_opening_accum_from_outside: 'Arrived with accumulated depreciation from before this system ({{n}} asset(s)) — check it was posted as an opening balance.',
  aw_far_rec_other: 'Another cause ({{n}} asset(s))',
  aw_far_rec_assets: 'Assets',
  aw_far_rec_more: 'and {{n}} more',
  aw_far_rec_open_asset: 'Open asset {{no}}',
  aw_far_rec_unexplained: 'Unexplained difference',
  aw_far_rec_balanced: 'Reconciled — the register agrees with the ledger once the reasons below are taken out.',
  aw_far_rec_unbalanced: 'Not reconciled — an unexplained difference of {{amount}}. Look for the account whose difference the reasons do not cover.',
};
export const zh: Record<string, string> = {
  aw_far_search_ph: '搜索资产编号、名称、供应商、发票号、位置或类别',
  aw_far_status_filter: '状态',
  aw_far_status_held: '仍持有',
  aw_far_status_all: '全部',
  aw_far_status_removed: '已删除',
  aw_far_cat_filter: '类别',
  aw_far_cat_all: '全部类别',
  aw_far_cat_none: '无类别',
  aw_far_from: '购入日期自',
  aw_far_to: '购入日期至',
  aw_far_clear: '清除搜索和筛选',
  aw_far_add: '新增资产',
  aw_far_add_title: '登记一项新资产',
  aw_far_import: '导入',
  aw_far_import_title: '从 CSV 或 Excel 文件导入整份资产登记簿',
  aw_far_recon_btn: '与总账核对',
  aw_far_recon_btn_title: '将登记簿与总账中的资产及累计折旧余额进行核对',
  aw_far_register_pdf: '法定登记簿（PDF）',
  aw_far_register_pdf_title: '本会计期间的资产登记簿（DBD 变动格式）',
  aw_far_sum_assets: '资产数',
  aw_far_sum_cost: '原值',
  aw_far_sum_accum: '累计折旧',
  aw_far_sum_nbv: '账面净值',
  aw_far_sum_sub: '按当前筛选结果合计',
  aw_far_sum_held: '其中 {{n}} 项仍持有——金额只合计这些',
  aw_far_sum_removed_sub: '已删除——不计入任何金额',
  aw_far_col_no: '资产编号',
  aw_far_col_name: '名称',
  aw_far_col_category: '类别',
  aw_far_col_start: '开始日期',
  aw_far_col_cost: '原值',
  aw_far_col_accum: '累计折旧',
  aw_far_col_nbv: '账面净值',
  aw_far_col_status: '状态',
  aw_far_col_actions: '操作',
  aw_far_sort_title: '按此列排序',
  aw_far_open: '打开',
  aw_far_open_title: '打开此资产',
  aw_far_none: '没有符合搜索和筛选条件的资产。',
  aw_far_start_title: '折旧从这一天开始：折旧开始日期；未填则为可供使用日期；再未填则为购入日期',
  aw_far_no_category_title: '无类别——在资产必须归类之前登记的',
  aw_far_overrides_title: '手工设定、未沿用类别的项目：{{list}}',
  aw_far_ovr_rate: '折旧率',
  aw_far_ovr_method: '折旧方法',
  aw_far_ovr_asset_account: '资产科目',
  aw_far_ovr_accum_account: '累计折旧科目',
  aw_far_ovr_expense_account: '折旧费用科目',
  aw_far_files_title: '{{n}} 份附件',
  aw_far_source_title: '由一笔费用记录购入',
  aw_far_nocat_title: '资产须先有类别',
  aw_far_nocat_body: '每项资产都属于一个类别——其科目、折旧率和折旧方法都来自类别。此客户尚无启用中的资产类别。',
  aw_far_nocat_btn: '设置资产类别',
  aw_far_not_found: '登记簿中没有资产 {{no}}。',
  aw_far_imported: '登记簿已导入——新资产已列在下方。',
  aw_far_note: '原值 = 购入价 + 资本化费用。卡片只合计当前搜索和筛选结果中仍持有的资产：已处置或已核销的资产已带走其原值和累计折旧，不再有账面净值（显示为 —），也不计入任何卡片。',
  aw_far_nbv_gone_title: '已离开登记簿——离开时的账面净值为 {{amount}}',
  aw_far_removed_by: '删除人：{{who}}',
  aw_far_removed_note: '已删除的资产是误登记后移出登记簿的。它们仍列在这里（加删除线），并注明删除人和时间——打开即可查看其变动记录。本页的任何金额都不计入它们。',
  aw_far_cat_err: '无法读取资产类别：{{why}}',
  aw_far_imp_title: '导入资产登记簿',
  aw_far_imp_cat: '未写类别的行使用此类别',
  aw_far_imp_cat_none: '— 每行自带类别 —',
  aw_far_imp_file: '文件（.csv 或 .xlsx）',
  aw_far_imp_help: '第一行为列名，可用英文、泰文或中文，顺序不限。必填：“名称”（另有“英文名称”可一并填写）、“购入日期”（或“取得日期”）和“原值”（或“成本”）。选填：“资产分类”、“资产类别”、“折旧率”、“残值”、“资产科目”、“累计折旧科目”和“折旧费用科目”（填科目代码）、“期初累计折旧”及其“截止日期”、“备注”、“供应商”、“发票号”、“资本化成本”、“可使用日期”、“折旧开始日期”、“存放地点”或“部门”、“状态”（“使用中”、“尚未可供使用”或“闲置”）以及“使用年限”。列名不在其中的列会被忽略，预览时会列出。点击导入之前不会写入任何内容——导入时要么全部登记，要么一行也不登记。',
  aw_far_imp_preview: '预览',
  aw_far_imp_commit: '导入 {{n}} 项资产',
  aw_far_imp_summary: '{{ok}} 行可登记 · {{refused}} 行被拒',
  aw_far_imp_fix: '被拒的行排在最前面。请在文件中修正后重新预览——导入只能全部或全不。',
  aw_far_imp_stale: '预览之后文件或类别已更改——请重新预览。',
  aw_far_imp_col_line: '行',
  aw_far_imp_col_date: '购入日期',
  aw_far_imp_col_name: '名称',
  aw_far_imp_col_category: '类别',
  aw_far_imp_col_cost: '原值',
  aw_far_imp_col_verdict: '结果',
  aw_far_imp_ok: '将被登记',
  aw_far_imp_for_file: '整份文件所选',
  aw_far_imp_read: '已读取的列：',
  aw_far_imp_ignored: '有 {{n}} 列将被忽略——其中的内容不会登记。如其中某列有用，请把列名改为上方说明所列的名称（或删除该列），然后重新预览。',
  aw_far_imp_column_n: '第 {{n}} 列：',
  aw_far_imp_no_heading: '（无列名）',
  aw_far_imp_twice: '又一个“{{field}}”列——只读取第一个',
  aw_far_imp_f_name_th: '名称（泰文）',
  aw_far_imp_f_name_en: '英文名称',
  aw_far_imp_f_class: '资产类别',
  aw_far_imp_f_category: '资产分类',
  aw_far_imp_f_acquired: '购入日期',
  aw_far_imp_f_cost: '原值',
  aw_far_imp_f_salvage: '残值',
  aw_far_imp_f_rate: '折旧率',
  aw_far_imp_f_asset_account: '资产科目',
  aw_far_imp_f_accum_account: '累计折旧科目',
  aw_far_imp_f_expense_account: '折旧费用科目',
  aw_far_imp_f_opening_accum: '期初累计折旧',
  aw_far_imp_f_opening_as_of: '期初累计折旧截止日期',
  aw_far_imp_f_note: '备注',
  aw_far_imp_f_vendor: '供应商',
  aw_far_imp_f_invoice_no: '供应商发票号',
  aw_far_imp_f_capitalised: '资本化成本',
  aw_far_imp_f_available: '可使用日期',
  aw_far_imp_f_dep_start: '折旧开始日期',
  aw_far_imp_f_location: '存放地点／部门',
  aw_far_imp_f_status: '状态',
  aw_far_imp_f_life: '使用年限',
  aw_far_rec_title: '登记簿与总账核对',
  aw_far_rec_asof: '截至 {{date}}',
  aw_far_rec_explain: '“原因”是两边各自就能证明的差异来源，因此从差额中扣除；“备注”值得留意但不能证明什么，因此从不扣除。扣除原因后剩下的就是无法解释的差额。',
  aw_far_rec_cost: '原值',
  aw_far_rec_accum: '累计折旧',
  aw_far_rec_col_account: '科目',
  aw_far_rec_col_register: '登记簿',
  aw_far_rec_col_ledger: '总账',
  aw_far_rec_col_diff: '差额',
  aw_far_rec_total: '合计',
  aw_far_rec_nbv: '账面净值',
  aw_far_rec_no_accounts: '登记簿中没有资产使用这里的科目。',
  aw_far_rec_reasons: '原因——已扣除',
  aw_far_rec_notes: '备注——从不扣除',
  aw_far_rec_none: '无。',
  aw_far_rec_r_depreciation_in_draft: '登记簿上已计提、但凭证仍是草稿的折旧（{{n}} 项资产）——请在“凭证”中过账。',
  aw_far_rec_r_depreciation_without_an_entry: '登记簿上有折旧、但完全没有对应凭证（{{n}} 项资产）。',
  aw_far_rec_r_disposal_not_posted: '登记簿上已处置、但处置凭证尚未过账（{{n}} 项资产）。',
  aw_far_rec_n_no_acquisition_entry_of_its_own: '没有自己的购入凭证（{{n}} 项资产）——原值通常是经由购入它的那笔采购进入总账的。',
  aw_far_rec_n_opening_accum_from_outside: '带着本系统之前的累计折旧转入（{{n}} 项资产）——请确认已作为期初余额过账。',
  aw_far_rec_other: '其他原因（{{n}} 项资产）',
  aw_far_rec_assets: '资产',
  aw_far_rec_more: '另有 {{n}} 项',
  aw_far_rec_open_asset: '打开资产 {{no}}',
  aw_far_rec_unexplained: '无法解释的差额',
  aw_far_rec_balanced: '已核平——扣除下列原因后，登记簿与总账一致。',
  aw_far_rec_unbalanced: '未核平——无法解释的差额为 {{amount}}。请查看原因未能覆盖其差额的科目。',
};
export const th: Record<string, string> = {
  aw_far_search_ph: 'ค้นหาเลขที่สินทรัพย์ ชื่อ ผู้ขาย เลขที่ใบกำกับ สถานที่ หรือหมวด',
  aw_far_status_filter: 'สถานะ',
  aw_far_status_held: 'ยังถือครองอยู่',
  aw_far_status_all: 'ทั้งหมด',
  aw_far_status_removed: 'ลบแล้ว',
  aw_far_cat_filter: 'หมวด',
  aw_far_cat_all: 'ทุกหมวด',
  aw_far_cat_none: 'ไม่มีหมวด',
  aw_far_from: 'วันที่ซื้อตั้งแต่',
  aw_far_to: 'วันที่ซื้อถึง',
  aw_far_clear: 'ล้างการค้นหาและตัวกรอง',
  aw_far_add: 'เพิ่มสินทรัพย์',
  aw_far_add_title: 'ลงทะเบียนสินทรัพย์ใหม่',
  aw_far_import: 'นำเข้า',
  aw_far_import_title: 'นำเข้าทะเบียนทั้งชุดจากไฟล์ CSV หรือ Excel',
  aw_far_recon_btn: 'กระทบยอดกับบัญชีแยกประเภท',
  aw_far_recon_btn_title: 'เปรียบเทียบทะเบียนกับยอดคงเหลือของบัญชีสินทรัพย์และค่าเสื่อมราคาสะสมในบัญชีแยกประเภททั่วไป',
  aw_far_register_pdf: 'ทะเบียนตามกฎหมาย (PDF)',
  aw_far_register_pdf_title: 'ทะเบียนสินทรัพย์ในรูปแบบการเคลื่อนไหวของกรมพัฒนาธุรกิจการค้า สำหรับรอบบัญชีนี้',
  aw_far_sum_assets: 'จำนวนสินทรัพย์',
  aw_far_sum_cost: 'ราคาทุน',
  aw_far_sum_accum: 'ค่าเสื่อมราคาสะสม',
  aw_far_sum_nbv: 'มูลค่าสุทธิตามบัญชี',
  aw_far_sum_sub: 'รวมตามที่ค้นหาและกรองอยู่',
  aw_far_sum_held: 'ในจำนวนนี้ยังถือครองอยู่ {{n}} รายการ — ยอดเงินรวมเฉพาะรายการเหล่านี้',
  aw_far_sum_removed_sub: 'ลบแล้ว — ไม่นับรวมในยอดใด',
  aw_far_col_no: 'เลขที่สินทรัพย์',
  aw_far_col_name: 'ชื่อ',
  aw_far_col_category: 'หมวด',
  aw_far_col_start: 'วันที่เริ่ม',
  aw_far_col_cost: 'ราคาทุน',
  aw_far_col_accum: 'ค่าเสื่อมสะสม',
  aw_far_col_nbv: 'มูลค่าสุทธิตามบัญชี',
  aw_far_col_status: 'สถานะ',
  aw_far_col_actions: 'การทำงาน',
  aw_far_sort_title: 'เรียงตามคอลัมน์นี้',
  aw_far_open: 'เปิด',
  aw_far_open_title: 'เปิดสินทรัพย์นี้',
  aw_far_none: 'ไม่มีสินทรัพย์ที่ตรงกับการค้นหาและตัวกรอง',
  aw_far_start_title: 'เริ่มคิดค่าเสื่อมราคาวันนี้: วันเริ่มคิดค่าเสื่อม ถ้าไม่มีใช้วันที่พร้อมใช้งาน ถ้าไม่มีอีกใช้วันที่ซื้อ',
  aw_far_no_category_title: 'ไม่มีหมวด — ลงทะเบียนไว้ก่อนที่สินทรัพย์ทุกรายการต้องมีหมวด',
  aw_far_overrides_title: 'กำหนดเอง ไม่ได้ใช้ค่าจากหมวด: {{list}}',
  aw_far_ovr_rate: 'อัตรา',
  aw_far_ovr_method: 'วิธีคิดค่าเสื่อม',
  aw_far_ovr_asset_account: 'บัญชีสินทรัพย์',
  aw_far_ovr_accum_account: 'บัญชีค่าเสื่อมราคาสะสม',
  aw_far_ovr_expense_account: 'บัญชีค่าเสื่อมราคา',
  aw_far_files_title: 'เอกสารประกอบ {{n}} ฉบับ',
  aw_far_source_title: 'ซื้อจากรายการค่าใช้จ่าย',
  aw_far_nocat_title: 'สินทรัพย์ต้องมีหมวดก่อน',
  aw_far_nocat_body: 'สินทรัพย์ทุกรายการอยู่ในหมวด — บัญชี อัตราค่าเสื่อม และวิธีคิดค่าเสื่อมมาจากหมวด ลูกค้ารายนี้ยังไม่มีหมวดสินทรัพย์ที่เปิดใช้งาน',
  aw_far_nocat_btn: 'ตั้งหมวดสินทรัพย์',
  aw_far_not_found: 'ไม่มีสินทรัพย์ {{no}} ในทะเบียน',
  aw_far_imported: 'นำเข้าทะเบียนแล้ว — สินทรัพย์ใหม่อยู่ในรายการด้านล่าง',
  aw_far_note: 'ราคาทุนคือราคาซื้อรวมต้นทุนที่บันทึกเพิ่ม การ์ดรวมเฉพาะสินทรัพย์ที่ยังถือครองอยู่ในผลการค้นหาและตัวกรอง สินทรัพย์ที่จำหน่ายหรือตัดจำหน่ายแล้วได้นำราคาทุนและค่าเสื่อมราคาสะสมออกไปด้วย จึงไม่มีมูลค่าตามบัญชี (—) และไม่นับรวมในการ์ดใด',
  aw_far_nbv_gone_title: 'ออกจากทะเบียนแล้ว — มูลค่าตามบัญชีขณะออกคือ {{amount}}',
  aw_far_removed_by: 'ลบโดย {{who}}',
  aw_far_removed_note: 'สินทรัพย์ที่ลบแล้วคือรายการที่ลงทะเบียนผิดพลาดและถูกนำออกจากทะเบียน ยังแสดงไว้ที่นี่โดยขีดฆ่า พร้อมผู้ลบและเวลา — เปิดเพื่ออ่านประวัติได้ ไม่มียอดใดในหน้านี้นับรวมรายการเหล่านี้',
  aw_far_cat_err: 'อ่านหมวดสินทรัพย์ไม่ได้: {{why}}',
  aw_far_imp_title: 'นำเข้าทะเบียนสินทรัพย์',
  aw_far_imp_cat: 'หมวดสำหรับแถวที่ไม่ได้ระบุหมวด',
  aw_far_imp_cat_none: '— แต่ละแถวระบุหมวดเอง —',
  aw_far_imp_file: 'ไฟล์ (.csv หรือ .xlsx)',
  aw_far_imp_help: 'แถวแรกเป็นชื่อคอลัมน์ เป็นภาษาอังกฤษ ไทย หรือจีน เรียงลำดับอย่างไรก็ได้ ต้องมี: “ชื่อ” (และ “ชื่ออังกฤษ” ถ้ามี) “วันที่ได้มา” และ “ราคาทุน” ไม่บังคับ: “หมวดสินทรัพย์” “ประเภทสินทรัพย์” “อัตราค่าเสื่อม” “มูลค่าคงเหลือ” “บัญชีสินทรัพย์” “บัญชีค่าเสื่อมสะสม” และ “บัญชีค่าใช้จ่าย” (ใส่รหัสบัญชี) “ค่าเสื่อมสะสมยกมา” พร้อม “ถึงวันที่” “หมายเหตุ” “ผู้ขาย” “เลขที่ใบกำกับ” “ต้นทุนที่บันทึกเพิ่ม” “วันที่พร้อมใช้งาน” “วันที่เริ่มคิดค่าเสื่อม” “สถานที่” หรือ “แผนก” “สถานะ” (“ใช้งานอยู่” “ยังไม่พร้อมใช้งาน” หรือ “ไม่ได้ใช้งาน”) และ “อายุการใช้งาน (ปี)” คอลัมน์ที่มีหัวอื่นจะถูกข้าม และหน้าตัวอย่างจะแจ้งชื่อไว้ ระบบจะไม่บันทึกอะไรจนกว่าจะกดนำเข้า — และจะบันทึกทุกแถวหรือไม่บันทึกเลย',
  aw_far_imp_preview: 'ดูตัวอย่าง',
  aw_far_imp_commit: 'นำเข้าสินทรัพย์ {{n}} รายการ',
  aw_far_imp_summary: 'ลงทะเบียนได้ {{ok}} แถว · ถูกปฏิเสธ {{refused}} แถว',
  aw_far_imp_fix: 'แถวที่ถูกปฏิเสธแสดงไว้ก่อน แก้ไขในไฟล์แล้วดูตัวอย่างอีกครั้ง — การนำเข้าต้องผ่านทุกแถวหรือไม่นำเข้าเลย',
  aw_far_imp_stale: 'ไฟล์หรือหมวดเปลี่ยนไปหลังจากดูตัวอย่าง — กรุณาดูตัวอย่างอีกครั้ง',
  aw_far_imp_col_line: 'แถว',
  aw_far_imp_col_date: 'วันที่ซื้อ',
  aw_far_imp_col_name: 'ชื่อ',
  aw_far_imp_col_category: 'หมวด',
  aw_far_imp_col_cost: 'ราคาทุน',
  aw_far_imp_col_verdict: 'ผล',
  aw_far_imp_ok: 'จะลงทะเบียน',
  aw_far_imp_for_file: 'หมวดที่เลือกให้ทั้งไฟล์',
  aw_far_imp_read: 'คอลัมน์ที่อ่าน:',
  aw_far_imp_ignored: 'จะข้าม {{n}} คอลัมน์ — ข้อมูลในคอลัมน์เหล่านี้จะไม่ถูกลงทะเบียน ถ้าคอลัมน์ใดจำเป็น ให้เปลี่ยนหัวคอลัมน์เป็นชื่อที่คำอธิบายด้านบนระบุ (หรือลบคอลัมน์นั้น) แล้วดูตัวอย่างอีกครั้ง',
  aw_far_imp_column_n: 'คอลัมน์ที่ {{n}}:',
  aw_far_imp_no_heading: '(ไม่มีหัวคอลัมน์)',
  aw_far_imp_twice: 'คอลัมน์ {{field}} ซ้ำเป็นคอลัมน์ที่สอง — อ่านเฉพาะคอลัมน์แรก',
  aw_far_imp_f_name_th: 'ชื่อ (ภาษาไทย)',
  aw_far_imp_f_name_en: 'ชื่อภาษาอังกฤษ',
  aw_far_imp_f_class: 'ประเภทสินทรัพย์',
  aw_far_imp_f_category: 'หมวดสินทรัพย์',
  aw_far_imp_f_acquired: 'วันที่ได้มา',
  aw_far_imp_f_cost: 'ราคาทุน',
  aw_far_imp_f_salvage: 'มูลค่าคงเหลือ',
  aw_far_imp_f_rate: 'อัตราค่าเสื่อม',
  aw_far_imp_f_asset_account: 'บัญชีสินทรัพย์',
  aw_far_imp_f_accum_account: 'บัญชีค่าเสื่อมสะสม',
  aw_far_imp_f_expense_account: 'บัญชีค่าใช้จ่ายค่าเสื่อมราคา',
  aw_far_imp_f_opening_accum: 'ค่าเสื่อมสะสมยกมา',
  aw_far_imp_f_opening_as_of: 'ยกมาถึงวันที่',
  aw_far_imp_f_note: 'หมายเหตุ',
  aw_far_imp_f_vendor: 'ผู้ขาย',
  aw_far_imp_f_invoice_no: 'เลขที่ใบกำกับของผู้ขาย',
  aw_far_imp_f_capitalised: 'ต้นทุนที่บันทึกเพิ่ม',
  aw_far_imp_f_available: 'วันที่พร้อมใช้งาน',
  aw_far_imp_f_dep_start: 'วันที่เริ่มคิดค่าเสื่อม',
  aw_far_imp_f_location: 'สถานที่ / แผนก',
  aw_far_imp_f_status: 'สถานะ',
  aw_far_imp_f_life: 'อายุการใช้งาน (ปี)',
  aw_far_rec_title: 'ทะเบียนเทียบกับบัญชีแยกประเภททั่วไป',
  aw_far_rec_asof: 'ณ วันที่ {{date}}',
  aw_far_rec_explain: 'สาเหตุคือสิ่งที่ทั้งสองฝั่งพิสูจน์ได้เอง จึงนำไปหักออกจากผลต่าง หมายเหตุเป็นข้อมูลที่ควรรู้แต่พิสูจน์อะไรไม่ได้ จึงไม่นำไปหักเลย ส่วนที่เหลือคือผลต่างที่อธิบายไม่ได้',
  aw_far_rec_cost: 'ราคาทุน',
  aw_far_rec_accum: 'ค่าเสื่อมราคาสะสม',
  aw_far_rec_col_account: 'บัญชี',
  aw_far_rec_col_register: 'ทะเบียน',
  aw_far_rec_col_ledger: 'บัญชีแยกประเภท',
  aw_far_rec_col_diff: 'ผลต่าง',
  aw_far_rec_total: 'รวม',
  aw_far_rec_nbv: 'มูลค่าสุทธิตามบัญชี',
  aw_far_rec_no_accounts: 'ไม่มีสินทรัพย์ในทะเบียนที่ใช้บัญชีในส่วนนี้',
  aw_far_rec_reasons: 'สาเหตุ — หักออกแล้ว',
  aw_far_rec_notes: 'หมายเหตุ — ไม่นำไปหัก',
  aw_far_rec_none: 'ไม่มี',
  aw_far_rec_r_depreciation_in_draft: 'ค่าเสื่อมราคาในทะเบียนที่รายการบัญชียังเป็นฉบับร่าง ({{n}} รายการ) — ผ่านรายการที่เมนูรายการบัญชี',
  aw_far_rec_r_depreciation_without_an_entry: 'ค่าเสื่อมราคาในทะเบียนที่ไม่มีรายการบัญชีรองรับเลย ({{n}} รายการ)',
  aw_far_rec_r_disposal_not_posted: 'จำหน่ายออกจากทะเบียนแล้วแต่รายการจำหน่ายยังไม่ได้ผ่านบัญชี ({{n}} รายการ)',
  aw_far_rec_n_no_acquisition_entry_of_its_own: 'ไม่มีรายการบันทึกการได้มาของตัวเอง ({{n}} รายการ) — ราคาทุนมักเข้าบัญชีแยกประเภทผ่านรายการซื้อที่ซื้อสินทรัพย์นั้น',
  aw_far_rec_n_opening_accum_from_outside: 'ยกค่าเสื่อมราคาสะสมมาจากก่อนใช้ระบบนี้ ({{n}} รายการ) — ตรวจสอบว่าได้บันทึกเป็นยอดยกมาแล้ว',
  aw_far_rec_other: 'สาเหตุอื่น ({{n}} รายการ)',
  aw_far_rec_assets: 'สินทรัพย์',
  aw_far_rec_more: 'และอีก {{n}} รายการ',
  aw_far_rec_open_asset: 'เปิดสินทรัพย์ {{no}}',
  aw_far_rec_unexplained: 'ผลต่างที่อธิบายไม่ได้',
  aw_far_rec_balanced: 'กระทบยอดตรงกันแล้ว — เมื่อหักสาเหตุด้านล่างออก ทะเบียนตรงกับบัญชีแยกประเภท',
  aw_far_rec_unbalanced: 'กระทบยอดไม่ตรง — มีผลต่างที่อธิบายไม่ได้ {{amount}} ให้ดูบัญชีที่สาเหตุไม่ครอบคลุมผลต่าง',
};
